module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAdUlEQVR42u3aoRGAQAADwViqQdAnlX1PQVFFVtxM9OqkbZYLAAAAAAAAAAAAAADrACedCgAAAAAAAAAAAAAAAAAAAAAAAACAcYA8b5cCAAAAAAAAAAAA8I9z3V0KAAAAAAAAAAAAgKMkAAAAAAAAAAAAAACTfdP9snBILMCfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Colombia.png
// module id = IbTm
// module chunks = 0 62 63